import { render } from "./Portofolio.vue?vue&type=template&id=73c2b9eb"
import script from "./Portofolio.vue?vue&type=script&lang=js"
export * from "./Portofolio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\zoinix-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__